// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordianController from "./accordian_controller.js"
application.register("accordian", AccordianController)

// import ArticleLoaderController from "./article_loader_controller.js"
// application.register("article-loader", ArticleLoaderController)

import AutoScrollingCardsController from "./auto_scrolling_cards_controller.js"
application.register("auto-scrolling-cards", AutoScrollingCardsController)

import AutoplayVideosController from "./autoplay_videos_controller.js"
application.register("autoplay-videos", AutoplayVideosController)

import BottomBarController from "./bottom_bar_controller.js"
application.register("bottom-bar", BottomBarController)

import BottomBarScrollTriggerController from "./bottom_bar_scroll_trigger_controller.js"
application.register('bottom-bar-scroll-trigger', BottomBarScrollTriggerController)

import ButtonLoaderController from "./button_loader_controller.js"
application.register("button-loader", ButtonLoaderController)

import CollectionsCardSliderController from "./collections_card_slider_controller.js"
application.register("collections-card-slider", CollectionsCardSliderController)

import CommentFormController from "./comment_form_controller.js"
application.register("comment-form", CommentFormController)

import ConfettiController from "./confetti_controller.js"
application.register("confetti", ConfettiController)

import CopyTextController from "./copy_text_controller.js"
application.register("copy-text", CopyTextController)

import CountdownTimerController from "./countdown_timer_controller.js"
application.register("countdown-timer", CountdownTimerController)

import CourseCompletedController from "./course_completed_controller.js"
application.register("course-completed", CourseCompletedController)

import CourseProgressBarController from "./course_progress_bar_controller.js"
application.register("course-progress-bar", CourseProgressBarController)

import CustomDropdownController from "./custom_dropdown_controller.js"
application.register("custom-dropdown", CustomDropdownController)

import CustomSelectController from "./custom_select_controller.js"
application.register("custom-select", CustomSelectController)

import CustomToggleController from "./custom_toggle_controller.js"
application.register("custom-toggle", CustomToggleController)

import FiltersController from "./filters_controller.js"
application.register("filters", FiltersController)

import FlashMessageController from "./flash_message_controller.js"
application.register("flash-message", FlashMessageController)

import FormController from "./form_controller.js"
application.register("form", FormController)

import GfsResultController from "./gfs_result_controller.js"
application.register("gfs-result", GfsResultController)

import GistsController from "./gists_controller.js"
application.register("gists", GistsController)

import HamburgerMenuController from "./hamburger_menu_controller.js"
application.register("hamburger-menu", HamburgerMenuController)

import HighlightsController from "./highlights_controller.js"
application.register("highlights", HighlightsController)

import ImageZoomController from "./image_zoom_controller.js"
application.register("image-zoom", ImageZoomController)

import ImmersivePageController from "./immersive_page_controller.js"
application.register("immersive-page", ImmersivePageController)

import LessonsMistakesToggleController from "./lessons_mistakes_toggle_controller.js"
application.register("lessons-mistakes-toggle", LessonsMistakesToggleController)

import LocationController from "./location_controller.js"
application.register("location", LocationController)

import MixpanelController from "./mixpanel_controller.js"
application.register("mixpanel", MixpanelController)

import ModuleDropdownController from "./module_dropdown_controller.js"
application.register("module-dropdown", ModuleDropdownController)

import MultilineInputController from "./multiline_input_controller.js"
application.register("multiline-input", MultilineInputController)

import NutshellTransitionController from "./nutshell_transition_controller.js"
application.register("nutshell-transition", NutshellTransitionController)

import OverviewController from "./overview_controller.js"
application.register("overview", OverviewController)

import PendingRequestsController from "./pending_requests_controller.js"
application.register("pending-requests", PendingRequestsController)

import ReadTriggerController from "./read_trigger_controller.js"
application.register("read-trigger", ReadTriggerController)

import ScrapeController from "./scrape_controller.js"
application.register("scrape", ScrapeController)

import ScrollSliderController from "./scroll_slider_controller.js"
application.register("scroll-slider", ScrollSliderController)

import ScrollToController from "./scroll_to_controller.js"
application.register("scroll-to", ScrollToController)

import ScrollToTopController from "./scroll_to_top_controller.js"
application.register("scroll-to-top", ScrollToTopController)

import ScrollTriggerController from "./scroll_trigger_controller.js"
application.register("scroll-trigger", ScrollTriggerController)

import SearchBoxController from "./search_box_controller.js"
application.register("search-box", SearchBoxController)

import SearchTabsController from "./search_tabs_controller.js"
application.register("search-tabs", SearchTabsController)

import ShareButtonController from "./share_button_controller.js"
application.register("share-button", ShareButtonController)

import ShowMoreController from "./show_more_controller.js"
application.register("show-more", ShowMoreController)

import SlideoverController from "./slideover_controller.js"
application.register("slideover", SlideoverController)

import SliderController from "./slider_controller.js"
application.register("slider", SliderController)

import SlimSelectController from "./slim_select_controller.js"
application.register("slim-select", SlimSelectController)

import StreamController from "./stream_controller.js"
application.register("stream", StreamController)

import TestimonialSliderController from "./testimonial_slider_controller.js"
application.register("testimonial-slider", TestimonialSliderController)

import TextChangeAnimationController from "./text_change_animation_controller.js"
application.register("text-change-animation", TextChangeAnimationController)

import TextClampController from "./text_clamp_controller.js"
application.register("text-clamp", TextClampController)

import TweetsSliderController from "./tweets_slider_controller.js"
application.register("tweets-slider", TweetsSliderController)

import VideoViewController from "./video_view_controller.js"
application.register("video-view", VideoViewController)
